import React from 'react';
import { useIntl } from 'react-intl';
import { InfoIcon } from '@panwds/icons';
import { classNames, testIdGen } from '../../utils/index.js';
import { Tooltip } from '../Tooltip/index.js';
/*
 * Handles rendering of form controls and their related properties like labels and errors.
 */
export function Field({ description, label, labelId, optional = false, error, dataMetrics, dataTestId, disabled, control, tooltip, showLabel = true, connectLabel = true, requiredAsterisk = false }) {
    const intl = useIntl();
    const labelTextClasses = classNames('tw-space-x-1 tw-flex tw-mb-2', !showLabel && 'tw-sr-only');
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || (label ? `field-${typeof label === 'string' && testIdGen(label)}` : 'field'), className: classNames('tw-font-lato tw-text-xs', disabled ? 'tw-text-disabled' : 'tw-text-secondary') },
        React.createElement("label", { className: "tw-block", id: labelId },
            React.createElement("div", { className: labelTextClasses },
                React.createElement("span", null, label),
                requiredAsterisk && React.createElement("span", { className: "tw-text-red-500 tw-top-1 tw-relative tw-text-[20px]" }, "*"),
                optional && (React.createElement("span", { className: "tw-text-secondary" }, intl.formatMessage({
                    defaultMessage: '(Optional)',
                    id: '6Pi4kz',
                    description: 'Field is optional'
                }))),
                tooltip && (React.createElement(Tooltip, { label: tooltip },
                    React.createElement(InfoIcon, { "aria-label": tooltip, className: "tw-text-disabled" })))),
            connectLabel && control),
        !connectLabel && control,
        error && React.createElement("div", { className: "tw-text-red dark:tw-text-red-400" }, error),
        description && (React.createElement("div", { className: classNames('tw-mt-1', disabled
                ? 'tw-text-disabled dark:tw-text-dark-bg-disabled'
                : 'tw-text-secondary dark:tw-text-dark-bg-secondary') }, description))));
}
//# sourceMappingURL=Field.js.map